import simpleRestProvider from 'ra-data-simple-rest';
import { DataProvider, GetListParams, GetListResult, RaRecord } from 'react-admin';
import { reviewsProxy } from './apiGateway';

interface Review extends RaRecord {
    id: string;
    user: {
        id: string;
        name: string;
        isActive: boolean;
    };
    lastUpdatedDate: string;
    content: {
        value: number;
        isTextExist: boolean;
        isPhotosExist: boolean;
    };
    itemInfo: {
        brand: string;
        model: string;
    };
}

interface ApiResponse {
    success: boolean;
    body: {
        reviews: Review[];
        cursor: string;
    };
}

interface ReviewDetailResponse {
    success: boolean;
    body: {
        id: string;
        state: string;
        users: {
            from: {
                id: string;
                name: string;
                isActive: boolean;
                avatarUrl?: string;
            };
            to: {
                id: string;
                name: string;
                isActive: boolean;
                avatarUrl?: string;
            };
        };
        date: string;
        content: {
            reviewGrade: number;
            text?: string;
            photosUrl?: string[];
        };
        deal: {
            orderId: string;
            brand: string;
            model: string;
            cancelled?: {
                wasBought: boolean;
                dealResult: string;
            };
        };
    };
}

export const reviewsDataProvider = {
    ...simpleRestProvider('/api/reviews'),
    getList: async (resource: string, params: GetListParams): Promise<GetListResult<Review>> => {
        const json: ApiResponse = await reviewsProxy.getList(params);

        const reviews = json.body.reviews.map(review => ({
            ...review,
            id: review.id || `${review.user.id}-${review.lastUpdatedDate}`,
            meta: {
                cursor: json.body.cursor || null
            }
        }));

        return {
            data: reviews,
            total: reviews.length,
            pageInfo: {
                hasNextPage: !!json.body.cursor,
                hasPreviousPage: false
            },
            meta: {
                cursor: json.body.cursor || null
            }
        };
    },
    getOne: async (resource: string, params: { id: string }) => {
        const json: ReviewDetailResponse = await reviewsProxy.getOne(params.id);
        
        if (!json.success) {
            throw new Error('Failed to fetch review details');
        }

        return {
            data: json.body
        };
    }
} as DataProvider; 